module.exports = __webpack_public_path__ + "static/media/mini-review-box-free.7162c21b.png";